/**
 * Generated by scripts/design-system/regenerate-design-system.cjs.
 * Source spec hash: 50fe5ed8529f4374d83db7550c185b50a7b658ac9aee9196b05221bb4be0e5ff
 */
import cn from 'classnames'
import React, { ComponentProps, ReactElement } from 'react'

import style from './NavFooter.style'

export const NavFooterCompositionDependencies = ['NavItem', 'Pill'] as const

export const NavFooterCompositionMetadata = [
  {
    "metadata": {
      "showUpgrade": false
    },
    "when": {
      "tier": [
        "pro",
        "enterprise"
      ]
    }
  }
] as const

type NavFooterOwnProps = {
  className?: string
  minimized?: boolean
  tier?: 'starter' | 'pro' | 'enterprise'
}

export type NavFooterProps = NavFooterOwnProps & Omit<ComponentProps<'div'>, keyof NavFooterOwnProps>

function NavFooter(props: NavFooterProps): ReactElement {
  const {
    children,
    className = '',
    minimized = false,
    tier = 'starter',
    ...rest
  } = props

  return (
    <div
      className={cn('NavFooter', className, tier, { minimized, 'not-minimized': !minimized })}
      css={style}
      {...rest}
      role='navigation'
    >
      {children}
    </div>
  )
}

export default NavFooter
